module.exports = __webpack_public_path__ + "img/banner_05.b209ee1e.png";